import { EQUIPMENT_TYPES } from './nurseAppModels';

/**
 * Default Equipment Catalogs
 * สร้างอัตโนมัติเมื่อสร้างทีมใหม่
 */
export const DEFAULT_CATALOGS = [
  // ========== อุปกรณ์ทางการแพทย์ ==========
  {
    name: 'เข็มฉีดยา 18G',
    code: 'CAT-NEEDLE-18G',
    description: 'เข็มฉีดยาขนาด 18G สำหรับการให้สารน้ำ',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์ฉีดยา',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: '18G',
    unit: 'เส้น',
    color: null,
    brand: null,
    model: null,
    minStock: 50,
    maxStock: 200,
    reorderPoint: 100,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['เข็ม', 'ฉีดยา', 'IV'],
    notes: 'Catalog เริ่มต้นสำหรับเข็มฉีดยา 18G',
    isDefault: true
  },
  {
    name: 'เข็มฉีดยา 20G',
    code: 'CAT-NEEDLE-20G',
    description: 'เข็มฉีดยาขนาด 20G สำหรับการให้สารน้ำ',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์ฉีดยา',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: '20G',
    unit: 'เส้น',
    color: null,
    brand: null,
    model: null,
    minStock: 50,
    maxStock: 200,
    reorderPoint: 100,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['เข็ม', 'ฉีดยา', 'IV'],
    notes: 'Catalog เริ่มต้นสำหรับเข็มฉีดยา 20G',
    isDefault: true
  },
  {
    name: 'เข็มฉีดยา 22G',
    code: 'CAT-NEEDLE-22G',
    description: 'เข็มฉีดยาขนาด 22G สำหรับการให้สารน้ำ',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์ฉีดยา',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: '22G',
    unit: 'เส้น',
    color: null,
    brand: null,
    model: null,
    minStock: 50,
    maxStock: 200,
    reorderPoint: 100,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['เข็ม', 'ฉีดยา', 'IV'],
    notes: 'Catalog เริ่มต้นสำหรับเข็มฉีดยา 22G',
    isDefault: true
  },
  {
    name: 'สายให้น้ำเกลือ (IV Set)',
    code: 'CAT-IV-SET',
    description: 'สายให้น้ำเกลือสำหรับการให้สารน้ำทางหลอดเลือดดำ',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์ให้สารน้ำ',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: null,
    unit: 'ชุด',
    color: null,
    brand: null,
    model: null,
    minStock: 30,
    maxStock: 100,
    reorderPoint: 50,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['IV', 'สายให้น้ำเกลือ', 'สารน้ำ'],
    notes: 'Catalog เริ่มต้นสำหรับสายให้น้ำเกลือ',
    isDefault: true
  },
  {
    name: 'ถุงน้ำเกลือ 500ml',
    code: 'CAT-SALINE-500ML',
    description: 'ถุงน้ำเกลือขนาด 500ml สำหรับการให้สารน้ำ',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์ให้สารน้ำ',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: '500ml',
    unit: 'ถุง',
    color: null,
    brand: null,
    model: null,
    minStock: 20,
    maxStock: 100,
    reorderPoint: 40,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['น้ำเกลือ', 'สารน้ำ', '500ml'],
    notes: 'Catalog เริ่มต้นสำหรับถุงน้ำเกลือ 500ml',
    isDefault: true
  },
  {
    name: 'ถุงน้ำเกลือ 1000ml',
    code: 'CAT-SALINE-1000ML',
    description: 'ถุงน้ำเกลือขนาด 1000ml สำหรับการให้สารน้ำ',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์ให้สารน้ำ',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: '1000ml',
    unit: 'ถุง',
    color: null,
    brand: null,
    model: null,
    minStock: 20,
    maxStock: 100,
    reorderPoint: 40,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['น้ำเกลือ', 'สารน้ำ', '1000ml'],
    notes: 'Catalog เริ่มต้นสำหรับถุงน้ำเกลือ 1000ml',
    isDefault: true
  },
  
  // ========== อุปกรณ์ดูแลผู้ป่วย ==========
  {
    name: 'ผ้าพันแผล',
    code: 'CAT-BANDAGE',
    description: 'ผ้าพันแผลสำหรับปิดแผล',
    category: 'อุปกรณ์ดูแลผู้ป่วย',
    subCategory: 'อุปกรณ์ทำความสะอาด',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: null,
    unit: 'ม้วน',
    color: null,
    brand: null,
    model: null,
    minStock: 10,
    maxStock: 50,
    reorderPoint: 20,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['ผ้าพันแผล', 'ปิดแผล'],
    notes: 'Catalog เริ่มต้นสำหรับผ้าพันแผล',
    isDefault: true
  },
  {
    name: 'สำลี',
    code: 'CAT-COTTON',
    description: 'สำลีสำหรับทำความสะอาดแผล',
    category: 'อุปกรณ์ดูแลผู้ป่วย',
    subCategory: 'อุปกรณ์ทำความสะอาด',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: null,
    unit: 'แพ็ค',
    color: null,
    brand: null,
    model: null,
    minStock: 20,
    maxStock: 100,
    reorderPoint: 50,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['สำลี', 'ทำความสะอาด'],
    notes: 'Catalog เริ่มต้นสำหรับสำลี',
    isDefault: true
  },
  {
    name: 'แอลกอฮอล์ 70%',
    code: 'CAT-ALCOHOL-70',
    description: 'แอลกอฮอล์ 70% สำหรับทำความสะอาด',
    category: 'อุปกรณ์ดูแลผู้ป่วย',
    subCategory: 'อุปกรณ์ทำความสะอาด',
    type: EQUIPMENT_TYPES.SMALL_ITEM,
    size: null,
    unit: 'ขวด',
    color: null,
    brand: null,
    model: null,
    minStock: 10,
    maxStock: 50,
    reorderPoint: 20,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: false,
    barcodePrefix: null,
    autoGenerateBarcode: false,
    tags: ['แอลกอฮอล์', 'ทำความสะอาด', '70%'],
    notes: 'Catalog เริ่มต้นสำหรับแอลกอฮอล์ 70%',
    isDefault: true
  },
  
  // ========== อุปกรณ์ชิ้นใหญ่ ==========
  {
    name: 'เครื่องวัดความดัน (BP Monitor)',
    code: 'CAT-BP-MONITOR',
    description: 'เครื่องวัดความดันโลหิต',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์วัดสัญญาณชีพ',
    type: EQUIPMENT_TYPES.LARGE_ITEM,
    size: null,
    unit: 'เครื่อง',
    color: null,
    brand: null,
    model: null,
    minStock: null,
    maxStock: null,
    reorderPoint: null,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: true,
    barcodePrefix: 'BP-',
    autoGenerateBarcode: true,
    tags: ['เครื่องวัดความดัน', 'BP', 'สัญญาณชีพ'],
    notes: 'Catalog เริ่มต้นสำหรับเครื่องวัดความดัน',
    isDefault: true
  },
  {
    name: 'เครื่องวัดอุณหภูมิ (Thermometer)',
    code: 'CAT-THERMOMETER',
    description: 'เครื่องวัดอุณหภูมิร่างกาย',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์วัดสัญญาณชีพ',
    type: EQUIPMENT_TYPES.LARGE_ITEM,
    size: null,
    unit: 'เครื่อง',
    color: null,
    brand: null,
    model: null,
    minStock: null,
    maxStock: null,
    reorderPoint: null,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: true,
    barcodePrefix: 'TEMP-',
    autoGenerateBarcode: true,
    tags: ['เครื่องวัดอุณหภูมิ', 'Thermometer', 'สัญญาณชีพ'],
    notes: 'Catalog เริ่มต้นสำหรับเครื่องวัดอุณหภูมิ',
    isDefault: true
  },
  {
    name: 'เครื่องดูดเสมหะ (Suction Machine)',
    code: 'CAT-SUCTION-MACHINE',
    description: 'เครื่องดูดเสมหะสำหรับผู้ป่วย',
    category: 'อุปกรณ์ทางการแพทย์',
    subCategory: 'อุปกรณ์ช่วยหายใจ',
    type: EQUIPMENT_TYPES.LARGE_ITEM,
    size: null,
    unit: 'เครื่อง',
    color: null,
    brand: null,
    model: null,
    minStock: null,
    maxStock: null,
    reorderPoint: null,
    defaultLocation: 'ตู้เก็บอุปกรณ์ 1',
    defaultDepartment: 'อายุรกรรม',
    defaultWard: 'หอผู้ป่วยอายุรกรรม',
    useBarcode: true,
    barcodePrefix: 'SUC-',
    autoGenerateBarcode: true,
    tags: ['เครื่องดูดเสมหะ', 'Suction', 'ช่วยหายใจ'],
    notes: 'Catalog เริ่มต้นสำหรับเครื่องดูดเสมหะ',
    isDefault: true
  }
];

/**
 * Pricing for Catalog Management
 */
export const CATALOG_PRICING = {
  CREATE_CATALOG: 50, // T Coins
  EDIT_CATALOG: 10,   // T Coins
  DELETE_CATALOG: 5   // T Coins
};



